import React from 'react';
import { Button } from 'primereact/button';

const PromoDisplayMode = ({ active, loading, onSelect }) => {
    return (
        <div className={`card h-100 ${active ? 'border-warning' : ''}`}>
            <div className="p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div>
                            <h4 className="mb-1">Promo Mode</h4>
                            <p className="text-muted mb-0">Show promotional content on customer display.</p>
                        </div>
                        <i className="pi pi-megaphone text-warning" style={{ fontSize: '2rem' }}></i>
                    </div>
                    {active && <span className="badge bg-warning text-dark">Active</span>}
                </div>

                <Button
                    type="button"
                    icon="pi pi-megaphone"
                    label={active ? 'Promo Mode Active' : 'Switch to Promo'}
                    severity="warning"
                    className="mt-4"
                    disabled={loading || active}
                    // onClick={() => onSelect('promo')}
                />
            </div>
        </div>
    );
};

export default PromoDisplayMode;
